import { DropdownMenu, Button } from '@radix-ui/themes';
import { useAudioOptions } from '@vidstack/react';

export const SmartPlayerAudio = () => {
    const options = useAudioOptions();

    console.log('🔊 ALL AUDIO OPTIONS:', options);
    console.log('🎯 SELECTED TRACK:', options.selectedTrack);

    if (options.length <= 1) return null;

    const activeLabel = options.selectedTrack?.label || 'Audio';

    return (
        <DropdownMenu.Root>
            <DropdownMenu.Trigger>
                <Button
                    variant='ghost'
                    color='gray'
                    highContrast
                    style={{
                        fontWeight: 'bold',
                    }}
                    title='Audio Tracks'
                >
                    {activeLabel.toUpperCase()}
                </Button>
            </DropdownMenu.Trigger>

            <DropdownMenu.Content
                variant='solid'
                color='gray'
                highContrast
                style={{ zIndex: 50 }}
            >
                {options.map(({ label, value, select }) => (
                    <DropdownMenu.Item
                        key={value}
                        onClick={() => select()}
                        style={{ cursor: 'pointer' }}
                    >
                        {label}

                        {options.selectedValue === value && (
                            <span style={{ marginLeft: '8px' }}>✓</span>
                        )}
                    </DropdownMenu.Item>
                ))}
            </DropdownMenu.Content>
        </DropdownMenu.Root>
    );
};
